import { Box, Grid, Typography } from "@mui/material";
import BaseButton from "../../BaseButton";

export default function ConfirmModal({ close, data }) {
  const { title, description, width, confirmText = 'Confirm', closeText = 'Close', onConfirm = () => {}, loadingConfirm = false } = data

  const handleClickConfirm = async () => {
    if (onConfirm) {
      await onConfirm()
    }
    close()
  }

  return (
    <Box sx={{
      width: '500px',
      maxWidth: width,
      borderRadius: '16px',
      boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
    }}>
      <Box sx={{
        padding: '16px'
      }}>
        <Typography 
          variant="h2"
          sx={{
            textAlign: 'center'
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            mt: '24px'
          }}
        >
          <Typography 
            variant="body"
            sx={{
              textAlign: 'center'
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
      <Box sx={{
        borderTop: '1px solid #CCCCCC',
        width: '100%',
        padding: '8px'
      }}>
        <Grid container spacing={'16px'}>
          <Grid item xs={6}>
            <BaseButton
              buttonType="default"
              height={'36px'}
              onClick={close}
            >
              {closeText}
            </BaseButton>
          </Grid>
          <Grid item xs={6}>
            <BaseButton
              buttonType="primary"
              height={'36px'}
              onClick={handleClickConfirm}
              loading={loadingConfirm}
            >
              {confirmText}
            </BaseButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}